/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-06 11:34:58
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-10-15 11:11:50
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/slice/selectors.ts
 */
/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-22 17:50:53
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-04-01 16:16:31
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/slice/selectors.ts
 * @LastEditTime: 2021-03-24 16:32:53
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/slice/selectors.ts
 */
import { createSelector } from '@reduxjs/toolkit';
import { EnumReducers } from './index';
import { EnumReducers as parentEnumReducers } from 'src/store';
import {
  getTarget,
  getSalesChannel as _getSalesChannel,
  getSalesChannelName as _getSalesChannelName,
  getGeneralFeaturedProduct as _getGeneralFeaturedProduct,
  getHasModified as _getHasModified,
  getCollapseValidationMsgDisplay as _getCollapseValidationMsgDisplay,
  getCollapseOpenStatus as _getCollapseOpenStatus,
  getState as _getState,
  getPageEnabled as _getPageEnabled,
  getLoaded as _getLoaded,
  getSubmitStamp as _getSubmitStamp,
  getH1TagUuid as _getH1TagUuid,
  getGeneralMiniProgramShare as _getGeneralMiniProgramShare,
  getGeneralMiniProgramPageInfo as _getGeneralMiniProgramPageInfo,
} from 'src/tools/selectors/salesChannel';

const reducers = (reducer) => {
  return [parentEnumReducers.salesChannelProducts, reducer];
};
export { parentEnumReducers, reducers, getTarget, EnumReducers };
export const getCollapseValidationMsgDisplay = (reducer, id) => {
  return _getCollapseValidationMsgDisplay(reducers(reducer), id);
};

export const getCollapseOpenStatus = (reducer, id) => {
  return _getCollapseOpenStatus(reducers(reducer), id);
};
export const getLoaded = (reducer) => {
  return _getLoaded(reducers(reducer));
};

export const getState = (reducer) => {
  return _getState(reducers(reducer));
};

export const getPageEnabled = (reducer) => {
  return _getPageEnabled(reducers(reducer));
};

export const getHasModified = (reducer) => {
  return _getHasModified(reducers(reducer));
};

export const getSalesChannel = (reducer) => {
  return _getSalesChannel(reducers(reducer));
};

export const getSalesChannelName = (reducer) => {
  return _getSalesChannelName(reducers(reducer));
};

export const getGeneralFeaturedProduct = (reducer) => {
  return _getGeneralFeaturedProduct(reducers(reducer));
};

export const getSubmitStamp = (reducer) => {
  return _getSubmitStamp(reducers(reducer));
};

export const getSalesChannelProduct = (reducer) => {
  return createSelector(
    (state: any) => getTarget(state, reducers(reducer)).salesChannelProduct,
    (salesChannelProduct) => {
      return salesChannelProduct;
    },
  );
};

export const getH1TagUuid = (reducer) => {
  return _getH1TagUuid(reducers(reducer));
};

export const getGeneralMiniProgramShare = (reducer) => {
  return _getGeneralMiniProgramShare(reducers(reducer));
};

export const getGeneralMiniProgramPageInfo = (reducer) => {
  return _getGeneralMiniProgramPageInfo(reducers(reducer));
};
